export default function AttRegulerizationIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={18}
        height={18}
        x={0}
        y={0}
        viewBox="0 0 64 64"
        // style={{ enableBackground: 'new 0 0 512 512' }}
        xmlSpace="preserve"
        className=""
      >
        <g>
          <path
            d="m32.859 44.867-1.982.266c.081.613.123 1.241.123 1.867h2c0-.714-.047-1.432-.141-2.133z"
            fill="#000000"
            opacity={1}
            data-original="#000000"
            className=""
          />
          <path
            d="M60 7h-1V4c0-1.654-1.346-3-3-3h-2c-1.654 0-3 1.346-3 3v3H23V4c0-1.654-1.346-3-3-3h-2c-1.654 0-3 1.346-3 3v3h-1c-1.654 0-3 1.346-3 3v22.178C5.144 34.557 1 40.3 1 47c0 8.822 7.178 16 16 16 6.619 0 12.423-4.099 14.821-10H60c1.654 0 3-1.346 3-3V10c0-1.654-1.346-3-3-3zm-7-3c0-.551.449-1 1-1h2c.551 0 1 .449 1 1v8c0 .551-.449 1-1 1h-2c-.551 0-1-.449-1-1zM17 4c0-.551.449-1 1-1h2c.551 0 1 .449 1 1v8c0 .551-.449 1-1 1h-2c-.551 0-1-.449-1-1zm13.876 44.868C29.955 55.784 23.99 61 17 61 9.28 61 3 54.72 3 47s6.28-14 14-14c6.279 0 11.829 4.222 13.497 10.266l1.928-.531C30.518 35.825 24.175 31 17 31c-1.383 0-2.719.195-4 .527V10c0-.551.449-1 1-1h1v3c0 1.654 1.346 3 3 3h2c1.654 0 3-1.346 3-3V9h28v3c0 1.654 1.346 3 3 3h2c1.654 0 3-1.346 3-3V9h1c.551 0 1 .449 1 1v9H19v2h42v19.879l-3.186-4.46a1.002 1.002 0 0 0-.687-.411 1.029 1.029 0 0 0-.768.224l-3.36 2.8V35h6v-2h-7a1 1 0 0 0-1 1v6.698L38.638 51h-6.157c.158-.611.293-1.23.378-1.868zm25.936-10.41 3.662 5.126L43.787 51h-2.025zM60 51H48.713L61 45.539V50c0 .552-.449 1-1 1z"
            fill="#000000"
            opacity={1}
            data-original="#000000"
            className=""
          />
          <path
            d="M15 19h2v2h-2zM23 30v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1zm-2-1h-4v-4h4zM34 31a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm-5-6h4v4h-4zM40 31h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm1-6h4v4h-4zM52 31h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm1-6h4v4h-4zM33 41h2v-7a1 1 0 0 0-1-1h-6v2h5zM40 41h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm1-6h4v4h-4zM24.707 38.293a.999.999 0 0 0-1.414 0L13 48.586l-3.293-3.293a.999.999 0 0 0-1.414 0l-3 3a.999.999 0 0 0 0 1.414l7 7a.997.997 0 0 0 1.414 0l14-14a.999.999 0 0 0 0-1.414zM13 54.586 7.414 49 9 47.414l3.293 3.293a.999.999 0 0 0 1.414 0L24 40.414 25.586 42z"
            fill="#000000"
            opacity={1}
            data-original="#000000"
            className=""
          />
        </g>
      </svg>
    </>
  );
}
